import { Form, Formik } from 'formik';

import { toast } from '@hivebrite/design-system/Toast';

import { MentoringFormContent } from 'hb-react/frontoffice/apps/Mentoring/components/MentoringFormContent';
import {
  type CustomAttributeType,
  type MentoringCreateFormikValues,
  type MentoringProfile,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { customAttributesInitialValues } from 'hb-react/shared/components/formik/utils/customAttributes';
import { type CustomAttributeFormValue } from 'hb-react/types';

interface MentoringCreateFormProps {
  applicationDescription: string;
  attributes: Array<CustomAttributeType>;
  onCreate: (payload: {
    [s: string]: CustomAttributeFormValue;
  }) => Promise<MentoringProfile>;
  onSuccess: () => void;
  title: string;
}

export const MentoringCreateForm = ({
  applicationDescription,
  attributes,
  onCreate,
  onSuccess,
  title,
}: MentoringCreateFormProps) => {
  const onSubmit = async (values: MentoringCreateFormikValues) => {
    try {
      await onCreate(values);
      toast.success(s__('Mentoring|Your request has been submitted'));
      onSuccess();
      // eslint-disable-next-line no-empty
    } catch {}
  };

  const initialValues =
    attributes.length > 0
      ? { ...customAttributesInitialValues(attributes) }
      : {};

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      enableReinitialize
    >
      <Form>
        <MentoringFormContent
          applicationDescription={applicationDescription}
          attributes={attributes}
          title={title}
        />
      </Form>
    </Formik>
  );
};
